import axios from 'axios'

const state = {
    list: [],
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
}

const options = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    }
};

const optionsFormData = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'multipart/form-data',
    }
};

const actions = {

    uploadSiteDocument(context, payload) {
        return axios.post(process.env.VUE_APP_API_STORAGE_BASE_URL+'/site_documents/upload', payload, optionsFormData)
            .then((response) => {
                return response
            })
    },

    uploadSitePlan(context, payload) {
        return axios.post(process.env.VUE_APP_API_STORAGE_BASE_URL+'/site_plans/upload', payload, optionsFormData)
            .then((response) => {
                return response
            })
    },

    addSiteDocument(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/site_documents', payload, options)
            .then((response) => {
                return response
            })
    },

    deleteSiteDocument(context, payload) {
        return axios.delete(process.env.VUE_APP_API_BASE_URL+'/site_documents/' + payload.id)
            .then((response) => {
                return response
            })
    },

    getPlanDetails(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL+'/site_documents/' + payload.documentId)
            .then((response) => {
                return response
            })
    },

    updatePlanInfos(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/site_documents/' + payload.documentId, payload, options)
            .then((response) => {
                return response
            })
    },

    updatePlanPositions(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/site_documents/' + payload.documentId + '/positions', payload, options)
            .then((response) => {
                return response
            })
    },

    updatePlanFile(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/site_documents/' + payload.documentId + '/file', payload, options)
            .then((response) => {
                return response
            })
    },

    updatePlanDevicesSizes(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/site_documents/' + payload.documentId + '/devices/sizes', payload, options)
            .then((response) => {
                return response
            })
    },

    updatePlanDevicesPlacement(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/site_documents/' + payload.documentId + '/devices/placement', payload, options)
            .then((response) => {
                return response
            })
    },

    generatePdf(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/site_documents/' + payload.documentId + '/pdf', payload, options)
            .then((response) => {
                return response
            })
    },

    deletePlan(context, payload) {
        return axios.delete(process.env.VUE_APP_API_BASE_URL+'/site_documents/' + payload.documentId + '/pdf')
            .then((response) => {
                return response
            })
    },

}

const getters = {
    list: state => state.list,
};

const site_documents = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default site_documents;
